export default __webpack_public_path__ + "static/media/Star.84fef584.png";